module.exports = __webpack_public_path__ + "img/budget-icon.7986e6c5.svg";